module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 79
// module chunks = 0